import { gql } from "lib/apolloClient";
import { standardRubricElementsFragment } from "./StandardRubricFragments";

export const bulkCreateStandardRubricCriteriaMutation = gql`
  mutation bulkCreateStandardRubricCriteria(
    $input: [CreateStandardRubricCriteriaInput!]
  ) {
    planner {
      bulkCreateStandardRubricCriteria(input: $input) {
        isSuccess
        warning
        response {
          ...standardRubricCriteriaItem
        }
      }
    }
  }
  ${standardRubricElementsFragment.criteria}
`;

export const createStandardRubricDescriptorMutation = gql`
  mutation createStandardRubricDescriptor(
    $input: CreateStandardRubricDescriptorInput!
  ) {
    planner {
      createStandardRubricDescriptor(input: $input) {
        isSuccess
        warning
        response {
          ...standardRubricDescriptorItem
        }
      }
    }
  }
  ${standardRubricElementsFragment.descriptor}
`;

export const bulkCreateStandardRubricDescriptorsMutation = gql`
  mutation bulkCreateStandardRubricDescriptors(
    $input: [CreateStandardRubricDescriptorInput!]
  ) {
    planner {
      bulkCreateStandardRubricDescriptors(input: $input) {
        isSuccess
        warning
        response {
          ...standardRubricDescriptorItem
        }
      }
    }
  }
  ${standardRubricElementsFragment.descriptor}
`;

export const updateStandardRubricCriteriasMutation = gql`
  mutation updateStandardRubricCriterias(
    $input: [UpdateStandardRubricCriteriaInput!]
  ) {
    planner {
      updateStandardRubricCriterias(input: $input) {
        isSuccess
        warning
        response {
          ...standardRubricCriteriaItem
        }
      }
    }
  }
  ${standardRubricElementsFragment.criteria}
`;

export const updateStandardRubricDescriptorsMutation = gql`
  mutation updateStandardRubricDescriptors(
    $input: [UpdateStandardRubricDescriptorInput!]
  ) {
    planner {
      updateStandardRubricDescriptors(input: $input) {
        isSuccess
        warning
        response {
          ...standardRubricDescriptorItem
        }
      }
    }
  }
  ${standardRubricElementsFragment.descriptor}
`;

export const removeStandardRubricCriteriasMutation = gql`
  mutation removeStandardRubricCriterias($input: [ID!]) {
    planner {
      removeStandardRubricCriterias(input: $input) {
        isSuccess
        warning
        response {
          ...standardRubricCriteriaItem
        }
      }
    }
  }
  ${standardRubricElementsFragment.criteria}
`;

export const removeStandardRubricDescriptorsMutation = gql`
  mutation removeStandardRubricDescriptors($input: [ID!]) {
    planner {
      removeStandardRubricDescriptors(input: $input) {
        isSuccess
        warning
        response {
          ...standardRubricDescriptorItem
        }
      }
    }
  }
  ${standardRubricElementsFragment.descriptor}
`;
